import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Select } from 'antd';
import { currencyUtils, getAbbreviatedValue, localStorageHelper } from 'utils';
import { FreeRoundType } from 'utils';

interface IProps {
    data: any;
    onCurrencyChange?: Function;
    currentCurrencyCode: string;
}

const PromotionalTotalComponent: React.FC<IProps & WithTranslation> = ({
    data,
    onCurrencyChange,
    currentCurrencyCode,
}) => {
    const userCurrencyData = currencyUtils.getActiveCurrencyData();
    const isUserCurrencyBillable = userCurrencyData.billable;
    const selectOptions = isUserCurrencyBillable
        ? [
              {
                  key: 'option-1',
                  value: 'user',
                  label: 'User Currency',
              },
              {
                  key: 'option-2',
                  value: 'campaign',
                  label: 'Campaign Currency',
              },
          ]
        : [
              {
                  key: 'option-2',
                  value: 'campaign',
                  label: 'Campaign Currency',
              },
          ];
    const defaultSelectValue = isUserCurrencyBillable ? 'user' : 'campaign';
    const isPrimaryFlow =
        localStorageHelper.getChainedValue('user.brandFeatures.freeRoundsType') ===
        FreeRoundType.PRIMARY_FLOW;

    const handleCurrencyChange = (value: any) => {
        if (onCurrencyChange) {
            onCurrencyChange(value);
        }
    };

    return data ? (
        <div className="bg-white rounded-xl border border-gray-200 px-6 py-4 flex flex-col w-full">
            <div className="flex justify-between items-start mb-2">
                <div className="text-xl font-semibold text-gray-900">Grand Total</div>
                <div className="flex items-center">
                    <Select
                        defaultValue={defaultSelectValue}
                        onChange={handleCurrencyChange}
                        options={selectOptions}
                        disabled={!isUserCurrencyBillable}
                        className="min-w-[160px]"
                    />
                </div>
            </div>
            <div className="grid grid-cols-4 gap-4 w-full">
                <div className="flex flex-col">
                    <span className="text-sm text-gray-400 mb-1">Total players</span>
                    <span className="text-2xl font-semibold text-gray-900">
                        {isPrimaryFlow ? data.totalPlayers : data.playedPlayersNumber}
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-sm text-gray-400 mb-1">Total bet</span>
                    <span className="text-2xl font-semibold text-gray-900">
                        {getAbbreviatedValue(data.totalBet, currentCurrencyCode, true, true)}{' '}
                        <span className="text-gray-400">{currentCurrencyCode}</span>
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-sm text-gray-400 mb-1">Total win</span>
                    <span className="text-2xl font-semibold text-gray-900">
                        {getAbbreviatedValue(
                            isPrimaryFlow ? data.totalWin : data.totalCompletedWin,
                            currentCurrencyCode,
                            true,
                            true,
                        )}{' '}
                        <span className="text-gray-400">{currentCurrencyCode}</span>
                    </span>
                </div>
                <div className="flex flex-col">
                    <span className="text-sm text-gray-400 mb-1">Played Rounds</span>
                    <span className="text-2xl font-semibold text-gray-900">
                        {data.totalPlayedFreeRounds}
                    </span>
                </div>
            </div>
        </div>
    ) : null;
};

export default withTranslation()(PromotionalTotalComponent);
